module.exports = __webpack_public_path__ + "img/recoating.39095bd3.png";